//@ts-nocheck
export const loadSwiperSliderBeer = () => {
    if (!document.querySelector("#sliderBeerSwiper")) return
    const swiper = new Swiper("#sliderBeerSwiper", {
      spaceBetween: 30,
      slidesPerView: 1,
      breakpoints: {
        480: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
      pagination: {
        el: "#sliderBeerSwiper .swiper-pagination",
      },
      navigation: {
        nextEl: "#sliderBeerSwiper .swiper-button-next",
        prevEl: "#sliderBeerSwiper .swiper-button-prev",
      },
    });
};
